import Vue from 'vue';
import { ToastPlugin } from 'bootstrap-vue';
import i18n from '@/i18n';

Vue.use(ToastPlugin);

const toastVm = new Vue({
    render: h => h('div'),
}).$mount();

document.body.appendChild(toastVm.$el);

export function alertSuccess({ message = 'Success', title = i18n.t('message.success') }) {
    const options = {
        variant: 'success',
        solid: true,
    };

    if (title) {
        options.title = title;
    }

    toastVm.$bvToast.toast(message, options);
}

export function alertError({ message = 'Error', title = i18n.t('message.error') }) {
    const options = {
        variant: 'danger',
        solid: true,
    };

    if (title) {
        options.title = title;
    }

    toastVm.$bvToast.toast(message, options);
}

export function alertWarning({ message = 'Warning', title = i18n.t('message.warning') }) {
    const options = {
        variant: 'warning',
        solid: true,
    };

    if (title) {
        options.title = title;
    }

    toastVm.$bvToast.toast(message, options);
}

export function alertInfo({ message = 'Info', title = i18n.t('message.info') }) {
    const options = {
        variant: 'info',
        solid: true,
    };

    if (title) {
        options.title = title;
    }

    toastVm.$bvToast.toast(message, options);
}